export type ThemeName = "light" | "dark" | "auto";
export type ConcreteThemeName = "light" | "dark";

export const checkThemeName = (
  themeName: string | undefined
): ThemeName | undefined => {
  if (themeName === undefined) {
    return undefined;
  }
  if (themeName === "auto") {
    return themeName;
  } else if (themeName === "light") {
    return themeName;
  } else if (themeName === "dark") {
    return themeName;
  } else {
    throw new Error("Invalid theme name: " + themeName);
  }
};
